export default __webpack_public_path__ + "static/media/docs.05f0963b.png";